import { render, staticRenderFns } from "./PriorityFilter.vue?vue&type=template&id=048a314c&scoped=true&"
import script from "./PriorityFilter.vue?vue&type=script&lang=js&"
export * from "./PriorityFilter.vue?vue&type=script&lang=js&"
import style0 from "./PriorityFilter.vue?vue&type=style&index=0&id=048a314c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048a314c",
  null
  
)

export default component.exports